<template>
    <div class="pharmacy">
        <div><img src="../../static/img/1q11.png" alt=""></div>
        <van-search v-model="value" placeholder="搜索药品、品牌、药店、功效" />
        <div v-for="(item, index) in pharmacyList" :key="index" class="card" :style="{ 'background-color': item.bgcolor }">
            <div>
                <div><van-icon name="shop-collect-o" />{{ item.name }}</div>
                <div @click="toBuyUrlByH5">点击进入<van-icon name="arrow" /></div>
            </div>
            <div>
                <div v-for="(goods, secondIndex) in item.goodsList" :key="secondIndex" class="goods">
                    <img :src="goods.url" alt="">
                    <div class="ori">原价:{{ goods.oriPrice }}</div>
                    <div class="pref">优惠价:{{ goods.prefPrice }}</div>
                </div>
            </div>
        </div>
        
        <div v-for="(item, index) in pharmacyList2" :key="index" class="card" :style="{ 'background-color': item.bgcolor }">
            <div>
                <div><van-icon name="shop-collect-o" />{{ item.name }}</div>
                <div @click="toYaodian">点击进入<van-icon name="arrow" /></div>
            </div>
            <div>
                <div v-for="(goods, secondIndex) in item.goodsList" :key="secondIndex" class="goods">
                    <img :src="goods.url" alt="">
                    <div class="ori">原价:{{ goods.oriPrice }}</div>
                    <div class="pref">优惠价:{{ goods.prefPrice }}</div>
                </div>
            </div>
        </div>        
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）

export default {
    // import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
      return {
        value: '',
        pharmacyList:[
            {
                name:'健康系列',
                bgcolor: '#d84c4f',
                goodsList:[
                    {
                        url:require(`@/static/img/goods.jpg`),
                        oriPrice: 23.5,
                        prefPrice: 16,
                    },
                    {
                        url:require(`@/static/img/goods.jpg`),
                        oriPrice: 23.5,
                        prefPrice: 16,
                    },
                    {
                        url:require(`@/static/img/goods.jpg`),
                        oriPrice: 23.5,
                        prefPrice: 16,
                    },
                ]
            }
        ],
        pharmacyList2:[
            {
                name:'其他药品',
                bgcolor: '#409983',
                goodsList:[
                    {
                        url:require(`@/static/img/goods.jpg`),
                        oriPrice: 23.5,
                        prefPrice: 16,
                    },
                    {
                        url:require(`@/static/img/goods.jpg`),
                        oriPrice: 23.5,
                        prefPrice: 16,
                    },
                    {
                        url:require(`@/static/img/goods.jpg`),
                        oriPrice: 23.5,
                        prefPrice: 16,
                    },
                ]
            }
        ]        
      };
    },
    methods: {
        
		toYaodian(){
			//this.toPukangByH5("WDCX");
			window.location.href = "https://pk-pl-h5-test.pukangbao.com/onlineShopQuery?cardCode=2023081500000079&signMD5=cc6409a1a22c1983f8d40e9b46ab004f&terminal=18&platformCode=lys&terminalType=3&thirdUserCode=511112195312191411";
			//window.location.href = "https://pk-pl-h5-test.pukangbao.com/onlineShopQuery?cardCode=6000090200000220&signMD5=c451420121adbd80fbd3d63179e25ec9&terminal=0";
		},
		toBuyUrlByH5(){
			
            this.$getRequestData('getBuyUrl', {lysCstUserId:sessionStorage.getItem('lysCstUserId')})
            .then(result => {
                if(result.resultCode == '0000'){
                    var h5_url = result.bizData.getBuyUrl;
                    console.log(h5_url)
                    window.location.href = h5_url;
                }else{
                    this.$toast.fail('获取链接失败');
                }

            })
		},        
    },
    computed: {},
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {},
};
</script>

<style lang="less" scoped>
//@import url(); 引入公共css类
img {
    width: 100%;
}
.card {
    margin: 10px 12px;
    background-color: #d84c4f;
    border-radius: 8px;
    padding: 10px;
    color: #fff;
    >div {
        display: flex;
        justify-content: space-between;
        margin-bottom: 6px;
        .goods{
            background: #fff;
            width: 120px;
            flex-direction: column;
            align-items: center;
            padding: 12px 0 10px;
            border-radius: 6px;
            img {
                width: 50%;
            }
            .ori {
                text-decoration: line-through;
                color: #6a6869;
                font-size: 12px;
            }
            .pref {
                color:#b15b45;
            }
        }
    }
}
</style>
